import {
  AccountModel,
  CompanyModel,
  ActivationOperationModel,
  AccountProviderModel,
} from '@/app/shared/models';
import { HttpService } from '@/app/shared/services/http.service';
import { env } from '@/environments';
import { refsService } from '../../refs.service';

export class CompanyService extends HttpService {
  public async getCompanyById(companyId: string): Promise<CompanyModel> {
    return await this.get<CompanyModel>(
      `${env.operationUri}/Companies/${companyId}`,
      { headers: { tenantId: refsService.modules.company.account.Id } }
    ).then(({ data }) => data);
  }
  public async getAccountById(accountId: string): Promise<AccountModel> {
    return await this.get<AccountModel>(
      `${env.operationUri}/Accounts/${accountId}`,
      { headers: { tenantId: refsService.modules.company.account.Id } }
    ).then(({ data }) => data);
  }

  public async getActivationsByAccoundId(
    accountId: string
  ): Promise<ActivationOperationModel[]> {
    return await this.get<ActivationOperationModel[]>(
      `${env.operationUri}/Accounts/${accountId}/Activations`
    ).then(({ data }) => data);
  }

  public async getActivationsByCompanyId(
    companyId: string
  ): Promise<ActivationOperationModel[]> {
    return await this.get<ActivationOperationModel[]>(
      `${env.operationUri}/Companies/${companyId}/Activations`
    ).then(({ data }) => data);
  }

  public async getAccountsByCompanyId(
    companyId: string
  ): Promise<AccountModel[]> {
    return await this.get<AccountModel[]>(
      `${env.operationUri}/Companies/${companyId}/Accounts`
    ).then(({ data }) => data);
  }
  public async getProvidersByAccoundId(
    accountId: string
  ): Promise<AccountProviderModel[]> {
    return await this.get<AccountProviderModel[]>(
      `${env.operationUri}/Accounts/${accountId}/accountProviders`
    ).then(({ data }) => data);
  }

  public async getProvidersByCompanyId(
    companyId: string
  ): Promise<AccountProviderModel[]> {
    return await this.get<AccountProviderModel[]>(
      `${env.operationUri}/Companies/${companyId}/accountProviders`
    ).then(({ data }) => data);
  }
}
